module.exports = __webpack_public_path__ + "static/media/Richardson,Nathaniel.b709d66c.png";